import Request from 'libs/requests';

export async function getMe() {
  const response = await Request.get('/users/user/');
  return response.data;
}

export async function postSignInProvider(provider: string, clientId: string, accessToken: string) {
  const response = await Request.post(
    `/users/${provider}/`,
    { clientId, access_token: accessToken },
  );
  return response.data;
}

export function postSignOut() {
  return Request.post('/users/logout/', {}).then(() => true);
}
